var React = require('react');

function EnvelopeMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.2703 0.304688H3.48631C2.71359 0.306799 1.97312 0.614696 1.42672 1.16109C0.880321 1.70749 0.572424 2.44797 0.570312 3.22069V21.4437C0.572424 22.2164 0.880321 22.9569 1.42672 23.5033C1.97312 24.0497 2.71359 24.3576 3.48631 24.3597H28.2703C29.043 24.3576 29.7835 24.0497 30.3299 23.5033C30.8763 22.9569 31.1842 22.2164 31.1863 21.4437V3.22069C31.1842 2.44797 30.8763 1.70749 30.3299 1.16109C29.7835 0.614696 29.043 0.306799 28.2703 0.304688ZM27.9063 6.50468L15.8783 14.5187L3.85031 6.50468V3.58469L15.8783 11.6047L27.9053 3.58469L27.9063 6.50468Z","fill":"#2CD0DB"}));
}

EnvelopeMobile.defaultProps = {"width":"32","height":"25","viewBox":"0 0 32 25","fill":"none"};

module.exports = EnvelopeMobile;

EnvelopeMobile.default = EnvelopeMobile;
